import Layout from '@/layouts/BasicLayout/index.vue'
import type { RouteRecordRaw } from 'vue-router'
import { DATA_CENTER_PATH } from '@/utils/micro-app'

const link: RouteRecordRaw = {
  path: DATA_CENTER_PATH,
  name: 'LeyoDataCenter',
  component: Layout,
  meta: {
    hideInMenu: true,
    title: '数据中台',
    icon: '数据中台|svg',
    module: 'GOODS_INFO_DETAIL',
    hidePageHeader: true
  },
  children: [
    {
      path: '#/product-info-detail-new',
      name: 'DataCenterGoodsInfoDetail',
      component: () => import('@/views/components/DocumentWrapper.vue'),
      meta: {
        hideInTab: true,
        hideInMenu: true,
        module: 'GOODS_INFO_DETAIL',
        title: '商品资料详情',
        replaceBack: true, // 针对微应用嵌入页面额外处理：点击返回上一页，使用replace而非push
        fuzzyMatch: true
      }
    }
  ]
}

export default link
